<template>
  <div id="step4" class="review-tips">
    <h3 class="text-success">入驻成功</h3>
    <div class="tips-info">
      系统将在&nbsp;
      <i class="text-error">{{ time }}</i>
      &nbsp;秒内自动为您跳转到入驻管理页面，您可从入驻管理模块查看企业信息和品牌信息审核进度
    </div>
    <div>
      <el-button class="mi-primary-plain" size="mini" @click="jumpToShop">查看</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      time: 5,
      timmer: null
    }
  },
  computed: {
    shopUrl() {
      const href = location.href
      if (href.indexOf('st') !== -1 || href.indexOf('dev') !== -1) {
        return 'http://shop.st.xiaomiyoupin.com/merchant/contact/detail'
      } else {
        return 'https://shop.xiaomiyoupin.com/merchant/contact/detail'
      }
    }
  },
  beforeDestroy() {
    this.timmer = null
    clearInterval(this.timmer)
  },
  mounted() {
    this.countDown()
  },
  methods: {
    countDown() {
      this.timer = setInterval(() => {
        --this.time
        if (this.time <= 0) {
          clearInterval(this.timer)
          // 这里跳转新路由
          const href = location.href
          if (href.indexOf('st') !== -1 || href.indexOf('dev') !== -1) {
            location.href = 'http://shop.st.xiaomiyoupin.com/'
          } else {
            location.href = 'https://shop.xiaomiyoupin.com/'
          }
        }
      }, 1000)
    },
    // 跳转到商家工作台
    jumpToShop() {
      window.open(this.shopUrl)
    }
  }
}
</script>
<style lang="less">
#step4 {
  height: 62vh;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding-top: 160px;
  box-sizing: border-box;

  h3 {
    color: #409eff;
    line-height: 1;
  }

  .tips-info {
    margin: 20px 0;
    color: #666;
  }
}
</style>
